import { render, staticRenderFns } from "./NotificationConfigureHeader.vue?vue&type=template&id=dd8d6946"
import script from "./NotificationConfigureHeader.vue?vue&type=script&lang=js"
export * from "./NotificationConfigureHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports